import styles from './styles.module.scss';
import Logo from '../../assets/images/signUp/logo.svg?react';
import LineBreak from '../../assets/images/signUp/lineBreak.svg?react';
import Button from '../Form/Button';
import Input from '../Form/Input';
import React from 'react';
import Footer from '../Footer';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Error } from '../Typography';
import { NewReleaseCard } from '../Card/NewReleaseCard/NewReleaseCard';

const inputClasses = {
  container: {
    width: 312,
  },
};

export default function PureCustomSignUp({
  inputs = [{}],
  onSubmit = () => {},
  disabled = undefined,
  GoogleLoginButton = undefined,
  classes = {},
  isChrome = true,
  errorMessage = undefined,
  isDashboardSignIn = false,
}) {
  const { t } = useTranslation();
  const wrongBrowserTop = t('SIGNUP.WRONG_BROWSER');
  const wrongBrowserBottom = t('SIGNUP.WRONG_BROWSER_BOTTOM');
  return (
    <form onSubmit={onSubmit} className={styles.home} style={classes.form}>
      <div className={styles.lander}>
        <div className={styles.greetContainer}>
          <Logo />
          {isDashboardSignIn && (
            <div className={styles.dashboardSignIn}>
              <div className={styles.dashboardSignInTitle}>{t('SIGNUP.DASHBOARD_CONTINUE_TO')}</div>
              <div className={styles.dashboardSignInSubtitle}>
                {t('SIGNUP.DASHBOARD_SIGN_IN_WITH')}
              </div>
            </div>
          )}
          {!isDashboardSignIn && (
            <NewReleaseCard style={{ marginTop: '32px', maxWidth: '312px' }} />
          )}
          {(!isChrome || !!errorMessage) && (
            <div className={styles.otherBrowserMessageTop}>
              {errorMessage ? (
                <Error style={{ maxWidth: '300px' }}>{errorMessage}</Error>
              ) : (
                <>
                  {wrongBrowserTop}
                  <div className={styles.otherBrowserMessageBottom}>{wrongBrowserBottom}</div>
                </>
              )}
            </div>
          )}

          <div data-cy="continueGoogle" className={styles.ssoButton}>
            {GoogleLoginButton}
          </div>
          <div className={styles.lineBreak}>
            <LineBreak />
          </div>

          <div className={styles.continueButton}>
            <Input data-cy="email" classes={inputClasses} {...inputs[0]} />
          </div>
        </div>
      </div>
      <Footer style={{ position: 'relative', bottom: 0, marginTop: '12px' }}>
        <div className={styles.bottomButton}>
          <Button
            disabled={disabled}
            style={{
              border: '4px',
              shadow: '0px 2px 8px rgba(102, 115, 138, 0.3)',
              width: 312,
              height: 48,
            }}
            type="submit"
            fullLength
            data-cy="continue"
          >
            {t('common:CONTINUE')}
          </Button>
        </div>
      </Footer>
    </form>
  );
}

PureCustomSignUp.prototype = {
  inputs: PropTypes.arrayOf(PropTypes.object),
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
  GoogleLoginButton: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.object),
  errorMessage: PropTypes.string,
  isDashboardSignIn: PropTypes.bool,
};
